import type { IView } from '@barba/core';
import textPageContentHandler from '@/inits/components/common/text-page-content-handler';

export default {
    namespace: 'legal-information-page',

    afterEnter() {
        textPageContentHandler.init();
    },
} as IView;
